import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { MobileCartBar } from "@/components/MobileCartBar";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-obsidian">
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">{children}</main>
      <Footer />
      <CartDrawer />
      <MobileCartBar />
    </div>
  );
}
